import { createSvgIcon } from '@material-ui/core';

export const DangerousIcon = createSvgIcon(
  <g transform="scale(1.111)">
    <path
      d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z"
      transform="translate(-1.2 -1.2)"
    />
  </g>,
  'DangerousIcon'
);
